export default {
      id: "document-usage",
      viewBox: "0 0 19 20",
      url: __webpack_public_path__ + "img/icons.svg#document",
      toString: function () {
        return this.url;
      }
    }